import { useEffect } from "react";
import confetti from "canvas-confetti";

interface ConfettiProps {
  trigger?: boolean;
}

export const triggerConfetti = () => {
  // Left burst
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { x: 0.2, y: 0.6 },
    colors: ['#F05B27', '#FF8C5A', '#FFD93D', '#22C55E', '#A855F7']
  });
  
  // Right burst
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { x: 0.8, y: 0.6 },
    colors: ['#F05B27', '#FF8C5A', '#FFD93D', '#22C55E', '#A855F7']
  });
  
  // Center shower with delay
  setTimeout(() => {
    confetti({
      particleCount: 50,
      spread: 100,
      origin: { x: 0.5, y: 0.3 },
      colors: ['#F05B27', '#FF8C5A', '#22C55E', '#A855F7', '#3B82F6']
    });
  }, 250);
};

const Confetti = ({ trigger = true }: ConfettiProps) => {
  useEffect(() => {
    if (trigger) {
      triggerConfetti();
    }
  }, [trigger]);

  return null;
};

export default Confetti;
